import React from "react";
import styles from "./EditIcon.module.scss";

function EditIcon(props) {
  return (
    <div
      data-testid="editIcon"
      id={"edit" + props.id}
      className={styles.Edit}
      onClick={props.onClick}
    >
      <div className={styles.RectangleStart}>&nbsp;</div>
      <div className={styles.RectangleEnd}>&nbsp;</div>
    </div>
  );
}

export default EditIcon;
